import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

const S = {
  nav: {
    background: '#1a1d24',
    borderBottom: '1px solid #2a2d35',
    padding: '0 24px',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  logo: {
    fontWeight: 900,
    fontSize: '28px',
    color: '#ffffff',
    textDecoration: 'none',
    letterSpacing: '-0.02em',
  },
  nav_links: { display: 'flex', alignItems: 'center', gap: '8px' },
  link: {
    color: '#9ca3af',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500,
    padding: '6px 12px',
    borderRadius: '6px',
    transition: 'color 0.15s, background 0.15s',
  },
  activeLink: {
    color: '#fff',
    background: '#2a2d35',
  },
  balance: {
    background: '#0f1115',
    border: '1px solid #2a2d35',
    borderRadius: '8px',
    padding: '6px 12px',
    fontSize: '13px',
    color: '#00e701',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  btn: {
    background: '#00e701',
    color: '#000',
    border: 'none',
    borderRadius: '8px',
    padding: '7px 16px',
    fontWeight: 700,
    fontSize: '13px',
    cursor: 'pointer',
  },
  btnOutline: {
    background: 'none',
    color: '#9ca3af',
    border: '1px solid #2a2d35',
    borderRadius: '8px',
    padding: '7px 16px',
    fontWeight: 600,
    fontSize: '13px',
    cursor: 'pointer',
  },
};

export default function Navbar() {
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const linkStyle = (path) => ({
    ...S.link,
    ...(isActive(path) ? S.activeLink : {}),
  });

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <nav style={S.nav}>
      <Link to="/" style={S.logo}>BETONMINES</Link>

      <div style={S.nav_links}>
        <Link to="/" style={linkStyle('/')}>Home</Link>
        {user && <Link to="/game" style={linkStyle('/game')}>Play</Link>}
        {user && <Link to="/deposit" style={linkStyle('/deposit')}>Deposit</Link>}
        {user && <Link to="/profile" style={linkStyle('/profile')}>Profile</Link>}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {user && profile && (
          <div style={S.balance}>
            ₿ {Number(profile.balance || 0).toFixed(2)}
          </div>
        )}
        {user ? (
          <button style={S.btnOutline} onClick={handleSignOut}>Sign Out</button>
        ) : (
          <button style={S.btn} onClick={() => navigate('/auth')}>Sign In</button>
        )}
      </div>
    </nav>
  );
}